import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createTimestampTransformer } from '../common/sql';
import { DBQuestionFaultSchema, QuestionFaultSchema } from './schemas';

export const QuestionFaultCodecConfig: TransformerConfig<
  typeof QuestionFaultSchema,
  typeof DBQuestionFaultSchema
> = {
  name: 'QuestionFault',
  clientSchema: QuestionFaultSchema,
  dbSchema: DBQuestionFaultSchema,
  transformers: [
    createTimestampTransformer<typeof QuestionFaultSchema, typeof DBQuestionFaultSchema>(
      'dismissedAt',
      { nullable: true }
    ),
    createTimestampTransformer<typeof QuestionFaultSchema, typeof DBQuestionFaultSchema>(
      'createdAt'
    ),
  ],
};

export const encodeQuestionFaultToDb = createEncodeToDbFn(QuestionFaultCodecConfig);
export const decodeQuestionFaultFromDb = createDecodeFromDbFn(QuestionFaultCodecConfig);
